import cn from 'classnames'
import { PartnerType } from 'legacy/lut/classes/models/PartnerType'
import { ScopeSelectKeys } from 'legacy/lut/components/widgets/public/partner360/composedReport'
import {
  changeScopeSelectValue,
  forceToggleGlobalsModal,
  selectPartnersInScope,
  selectScopeSelectValue,
} from 'legacy/lut/features/partner360/composedReport'
import { Dropdown } from 'legacy/lut/library/dropdown'
import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Nullable } from 'clickNgo/models/utils'
import { Button } from 'core-components/library/button'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { TRANSLATION_KEYS } from '../../../../translations/TRANSLATION_KEYS'

import { getData } from './helpers/getData'

import styles from './ScopeSelect.module.scss'

interface IProps {
  value: string
  partnersType: Nullable<PartnerType>
  onChange: (value: string) => void
  className?: string
}

export const ScopeSelect = ({ value, onChange, className, partnersType }: IProps) => {
  const scopeSelectValue = useSelector(selectScopeSelectValue)
  const partnersInScope = useSelector(selectPartnersInScope)
  const dispatch = useDispatch()

  const source = useMemo(() => {
    const data = getData(partnersType)

    return new Crud({
      fetcher: new Static(data),
      defaultPaging: {
        page: 0,
        pageSize: data.length,
      },
      keyField: 'value',
    })
  }, [partnersType])

  const handleChange = useCallback(
    (value: string) => {
      onChange(value)
    },
    [onChange]
  )

  const handleChangeScopeSelectValue = useCallback(() => {
    dispatch(changeScopeSelectValue(ScopeSelectKeys.All))
  }, [dispatch])

  const forceOpenGlobalsModal = useCallback(() => {
    dispatch(forceToggleGlobalsModal(true))
  }, [dispatch])

  return (
    <div className={cn(className, styles.row)}>
      <Dropdown
        translation={TRANSLATION_KEYS.scopeField}
        value={value}
        source={source}
        caption={'label'}
        onChange={handleChange}
        classes={{
          controlClasses: {
            root: styles.select,
          },
        }}
      />
      {scopeSelectValue === ScopeSelectKeys.ManualGlobal && partnersInScope.length > 0 ? (
        <div className={styles.row__selected}>
          <span className={styles.text}>
            {partnersInScope[0].CommunicationName || partnersInScope[0].PartnerID}
          </span>
          <Button
            className={styles.iconButton}
            iconButton="kbase kbase-close kbase-sm"
            color="danger"
            variant={'text'}
            onClick={handleChangeScopeSelectValue}
          />
        </div>
      ) : null}
      {scopeSelectValue === ScopeSelectKeys.ManualGlobal ? (
        <Button
          className={styles.iconButton}
          iconButton="kbase kbase-settings-alt"
          color="primary"
          variant={'text'}
          onClick={forceOpenGlobalsModal}
        />
      ) : null}
    </div>
  )
}
